import { Template } from "../api/service";

export const useTemplate = () => {
  const getList = Template.GET.getList;
  const getTemplateById = Template.GET.getTemplateById;
  const getTemplateFields = Template.GET.getTemplateFields;
  return {
    getList,
    getTemplateById,
    getTemplateFields,
  };
};
